module.exports = __webpack_public_path__ + "img/pdfBackground.a0d936a8.png";